import defaultTranslations from 'translation/default';

const userTranslations = {};

function getTr (key) {
  const custom = userTranslations[key];
  if (custom) {
    if (typeof custom === 'function') {
      return custom();
    }
    return custom;
  }
  if (!defaultTranslations[key]) {
    console.error(`Translation for [${key}] is not present`);
  }
  return defaultTranslations[key];
}

function setupTranslations (Vue, translations = {}) {
  Object.keys(translations).forEach(k => {
    userTranslations[k] = translations[k];
  });

  Vue.prototype._getTr = getTr;
}

export default getTr;
export {setupTranslations};
